// Feature Toggle API endpoints (RTK Query)
import baseApi, { apiTags } from '../api/baseApi'

export const FEATURE_TOGGLE_ERROR_TYPES = {
  BAD_REQUEST: 'BAD_REQUEST',
  NOT_FOUND: 'NOT_FOUND',
  SERVER_ERROR: 'SERVER_ERROR',
}

const transformErrorResponse = response => {
  if (response.status === 400)
    return { errorType: FEATURE_TOGGLE_ERROR_TYPES.BAD_REQUEST }
  if (response.status === 404)
    return { errorType: FEATURE_TOGGLE_ERROR_TYPES.NOT_FOUND }

  return {
    errorType: FEATURE_TOGGLE_ERROR_TYPES.SERVER_ERROR,
    message: response.data?.message,
  }
}

const featureToggleApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchFeatureToggleList: builder.query({
      providesTags: [apiTags.FEATURE_TOGGLE],
      query: () => 'feature-toggle/list',
    }),

    fetchFeatureToggleById: builder.query({
      query: id => ({ params: { id }, url: 'feature-toggle' }),
    }),

    createFeatureToggle: builder.mutation({
      invalidatesTags: [apiTags.FEATURE_TOGGLE],
      query: payload => ({
        body: payload,
        method: 'POST',
        url: 'feature-toggle',
      }),
      transformErrorResponse,
    }),

    updateFeatureToggle: builder.mutation({
      invalidatesTags: [apiTags.FEATURE_TOGGLE],
      query: payload => ({
        body: payload,
        method: 'PUT',
        url: 'feature-toggle',
      }),
      transformErrorResponse,
    }),
  }),
})

export const {
  useFetchFeatureToggleListQuery,
  useLazyFetchFeatureToggleByIdQuery,
  useCreateFeatureToggleMutation,
  useUpdateFeatureToggleMutation,
} = featureToggleApi

export default featureToggleApi
